import { useState } from 'react'
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material'
import logo from '../assets/logo/Logo multicolore_Fond transparent 1.svg.svg'
import { useAuth } from 'contexts/AuthContext'
import { useNavigate } from 'react-router-dom' // <-- NEW: Import useNavigate

export default function LoginPage() {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const auth = useAuth()
  const navigate = useNavigate() // <-- NEW: Initialize navigate

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!login || !password) {
      setError('Identifiant et mot de passe sont requis.')
      return
    }
    setError('')
    setIsSubmitting(true)
    try {
      await auth.login(login, password)
      // NEW: Navigate on successful login
      navigate('/dashboard')
    } catch (err: any) {
      console.error(err)
      setError(
        err.response?.data?.message ||
          'La connexion a échoué. Veuillez vérifier vos identifiants.'
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 2,
      }}
    >
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: '400px',
          justifyContent: 'center',
          alignItems: 'center',
          p: 3,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: 'background.paper',
        }}
      >
        <img
          src={logo}
          alt="logo"
          style={{ maxWidth: '200px', marginBottom: '1rem' }}
        />
        <Typography variant="h6" sx={{ mb: 2 }}>
          Interface Administrateur
        </Typography>

        {error && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          fullWidth
          required
          variant="outlined"
          label="Identifiant"
          value={login}
          onChange={(event) => setLogin(event.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth
          required
          variant="outlined"
          label="Mot de passe"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          sx={{ mb: 2 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={isSubmitting}
          sx={{ p: 1.5 }}
        >
          {isSubmitting ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Se connecter'
          )}
        </Button>
      </Box>
    </Box>
  )
}
